import { Button, ButtonGroup } from "react-bootstrap";
import "./BaseButtonGroup.sass";

export default function BaseButtonGroup (props) {
    const {
        options = [],
        value,
        onClickHandler = () => {},
        className = ','
    } = props;

    return (
        <ButtonGroup
            className={`base-button-group ${className}`}
            size="sm"
        >
            {options.map((option) => (
                <Button
                    key={`base_button_type_${option.value}`}
                    onClick={() => onClickHandler(option.value)}
                    variant={option.value === value ? 'primary' : 'secondary'}
                >
                    {option.name}
                </Button>
            ))}
        </ButtonGroup>
    )
}
